let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kPtjD")).then(() => parcelRequire('2yoxc'));